import React from 'react';
import Popup from 'reactjs-popup';
import LoadScreen from '../loadScreen/loadScreen';

export default function LoadScreenSmall({open,close}){
    const popupStyle = {
        width:'100vw',
        height:'100vh',
        backgroundColor:'RGBA(0,0,0,0.1)',
        display:"flex",
        justifyContent:'center',
        alignItems:'center'
    }
    return(
        <Popup open={open}
            onClose={()=>close(false)}
            contentStyle={popupStyle} >
                <div style={{position:'absolute',width:'70vw', height:'80vh'}} >
                    <LoadScreen  background='unset' position='unset'/>
                </div>
        </Popup>
    )
}
